
export class LinkGenderConventionExtension {
    selected: boolean;
}
